export default __webpack_public_path__ + "static/gearsPop-59aaa556392b07a98e816988cb058c9b.svg";